//https://product.hubteam.com/docs/crm-objects/getting-started/index.html & https://git.hubteam.com/HubSpot/InboundDbMeta/blob/7206e6bf775e766adc6f33ddcf3fa7a1b2ae356a/InboundDbCore/src/main/java/com/hubspot/inbounddb/base/MetaType.java
export const CRM_OBJECT_META_TYPE = {
  HUBSPOT: 0,
  INTEGRATION: 1,
  PORTAL_SPECIFIC: 2,
  CMS_HUBDB: 3,
  HUBSPOT_EVENT: 4,
  INTEGRATION_EVENT: 5,
  PORTAL_SPECIFIC_EVENT: 6
};